angular.module('picmonicng').directive('scrollTo', [
  function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        if (scope.$eval(attrs.scrollTo)) {
          var parent = angular.element('.browse__wrapper').has(element).length ? '.browse__content' : 'html';
          setTimeout(function () {
            angular.element(parent).animate(
              {
                scrollTop: element.offset().top - 93 + 'px',
              },
              'fast'
            );
          }, 3000);
        }
      },
    };
  },
]);
